module.exports = __webpack_public_path__ + "img/ctrl-c-stub-up-0.aa9e4011.svg";